import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import {
    Input,
    TextArea as HelpTextArea,
    InputNumeric,
    Form,
    Switch,
    Button
} from '@gpstrackit/gtc-react-controls';

const TextArea = (props) => {
    const { messages } = useIntl();
    const questionForm = Form.useForm();

    const {
        question,
        handleClose,
        updateQuestion
    } = props;

    const open = useSelector(state => state.dynamicFormsDesignRedux.openQuestionConfiguration);
    const loading = useSelector(state => state.dynamicFormsDesignRedux.loading);

    const [formData,  setFormData] = useState({});

    useEffect(() => {
        if (open && questionForm?.ref && question) {
            questionForm?.setValues({
                ...question,
                maxLength: question?.attributes?.maxLength,
                default: question?.attributes?.default
            });
        }
    }, [questionForm?.ref, open, question]);

    return (
        <div>
            <Form
                ref={questionForm?.ref}
                loading={loading}
                onValidSubmit={(values) => {
                    let newQuestion = {
                        ...question,
                        label: values?.label,
                        placeHolder: values?.placeHolder,
                        help: values?.help,
                        required: values?.required,
                        readOnly: values?.readOnly,
                        attributes: {
                            maxLength: values?.maxLength,
                            default: values?.default,
                        }
                    }

                    updateQuestion(newQuestion);
                }}
                onChangeValues={(newValues) => {
                    setFormData(newValues);
                }}
            >
                <div>
                    <Form.Item
                        name="label"
                        label={messages['dynamicFormsDesign_label']}
                        rules={[{ required: true, message: 'required_field' }]}
                    >
                        <Input
                            id="label"
                            type="text"
                            placeholder={messages['dynamicFormsDesign_label']}
                            maxLength={100}
                        />
                    </Form.Item>

                    <Form.Item
                        name="placeHolder"
                        label={messages['dynamicFormsDesign_placeholder']}
                    >
                        <Input
                            id="placeHolder"
                            type="text"
                            placeholder={messages['dynamicFormsDesign_placeholder']}
                            maxLength={100}
                        />
                    </Form.Item>

                    <Form.Item
                        name="help"
                        label={messages['dynamicFormsDesign_helpText']}
                    >
                        <HelpTextArea
                            id="help"
                            placeholder={messages['dynamicFormsDesign_helpText']}
                            maxLength={1000}
                        />
                    </Form.Item>

                    <Form.Item
                        name="required"
                        label={messages['dynamicFormsDesign_required']}
                    >
                        <Switch
                            id="required"
                            optionLabels={[
                                messages['dynamicFormsDesign_yes'],
                                messages['dynamicFormsDesign_no']
                            ]}
                            onChange={(value) => {
                                let timer = setTimeout(() => {
                                    const newFormData = {
                                        ...formData,
                                        readOnly: false
                                    };

                                    setFormData(newFormData);
                                    questionForm?.setValues(newFormData);
                                    timer = null;
                                }, 50);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="readOnly"
                        label={messages['dynamicFormsDesign_readOnly']}
                    >
                        <Switch
                            id="readOnly"
                            optionLabels={[
                                messages['dynamicFormsDesign_yes'],
                                messages['dynamicFormsDesign_no']
                            ]}
                            onChange={(value) => {
                                let timer = setTimeout(() => {
                                    const newFormData = {
                                        ...formData,
                                        required: false
                                    };

                                    setFormData(newFormData);
                                    questionForm?.setValues(newFormData);
                                    timer = null;
                                }, 50);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="maxLength"
                        label={messages['dynamicFormsDesign_maxlength']}
                        rules={[
                            { required: true, message: 'required_field' },
                            { min: 1, message: `${messages['min']}: 1` },
                            { max: 1000, message: `${messages['max']}: 1000` }
                        ]}
                    >
                        <InputNumeric
                            id="maxLength"
                            type="number"
                            isInteger={true}
                            placeholder={messages['dynamicFormsDesign_maxlength']}
                        />
                    </Form.Item>

                    <Form.Item
                        name="default"
                        label={messages['dynamicFormsDesign_defaultValue']}
                    >
                        <Input
                            id="default"
                            type="text"
                            placeholder={messages['dynamicFormsDesign_defaultValue']}
                            maxLength={500}
                        />
                    </Form.Item>
                </div>
            </Form>

            <div style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                    style={{ marginRight: 8 }}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        questionForm?.resetValues()
                        handleClose();
                    }}
                    variant='secondary'
                >
                    {messages['cancel']}
                </Button>

                <Button
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        questionForm?.submit();
                    }}
                    variant='primary'
                >
                    {messages['save']}
                </Button>
            </div>
        </div>
    );
}

export default TextArea;